import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/guards/auth.guard';
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./login-layout/login-module.module').then(m => m.LoginModuleModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./master-layout/master-layout-routing.module').then(m => m.MasterLayoutRoutingModule), canActivate: [AuthGuard]
  },
 
  
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, 
    { useHash: false, onSameUrlNavigation: 'reload' ,scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }





